import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="py-8 px-4 bg-brand-black border-t border-white/5" data-id="element-81">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-82">
          <p className="text-gray-500 font-inter text-sm" data-id="element-83">
            © {new Date().getFullYear()} Etiquetas Sin Mentiras. Todos los
            derechos reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-84">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-brand-neon font-inter text-sm transition-colors cursor-pointer" data-id="element-85">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-brand-neon font-inter text-sm transition-colors cursor-pointer" data-id="element-86">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-87">
        <p data-id="element-88">
          <strong className="text-white" data-id="element-89">Última actualización:</strong> Abril
          2026
        </p>
        <p data-id="element-90">
          Tu privacidad es importante para nosotros. Esta política describe cómo
          recopilamos, usamos y protegemos tu información personal cuando
          adquieres nuestros productos digitales.
        </p>
        <h4 className="text-white font-semibold text-base mt-4" data-id="element-91">
          1. Información que recopilamos
        </h4>
        <p data-id="element-92">
          Recopilamos únicamente la información necesaria para procesar tu
          compra: nombre, dirección de correo electrónico y datos de pago. No
          almacenamos datos de tarjetas de crédito directamente; estos son
          procesados por plataformas de pago seguras de terceros.
        </p>
        <h4 className="text-white font-semibold text-base mt-4" data-id="element-93">
          2. Uso de la información
        </h4>
        <p data-id="element-94">
          Utilizamos tu información exclusivamente para: entregar el producto
          digital adquirido, enviar confirmaciones de compra y comunicarnos
          contigo sobre actualizaciones del producto si has dado tu
          consentimiento.
        </p>
        <h4 className="text-white font-semibold text-base mt-4" data-id="element-95">
          3. Protección de datos
        </h4>
        <p data-id="element-96">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal contra acceso no autorizado,
          alteración o destrucción.
        </p>
        <h4 className="text-white font-semibold text-base mt-4" data-id="element-97">4. Terceros</h4>
        <p data-id="element-98">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto a proveedores de servicios de pago necesarios para
          completar tu transacción.
        </p>
        <h4 className="text-white font-semibold text-base mt-4" data-id="element-99">
          5. Tus derechos
        </h4>
        <p data-id="element-100">
          Tienes derecho a solicitar acceso, corrección o eliminación de tus
          datos personales en cualquier momento.
        </p>
      </Modal>

      {/* Terms & Conditions Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-101">
        <p data-id="element-102">
          <strong className="text-white" data-id="element-103">Última actualización:</strong> Abril
          2026
        </p>
        <p data-id="element-104">
          Al adquirir cualquier producto digital de "Etiquetas Sin Mentiras",
          aceptas los siguientes términos y condiciones.
        </p>
        <h4 className="text-white font-semibold text-base mt-4" data-id="element-105">
          1. Producto digital
        </h4>
        <p data-id="element-106">
          Este es un producto digital en formato PDF. Una vez completada la
          compra, recibirás acceso inmediato para descargar todos los materiales
          incluidos. No se realizan envíos físicos.
        </p>
        <h4 className="text-white font-semibold text-base mt-4" data-id="element-107">
          2. Uso personal
        </h4>
        <p data-id="element-108">
          El contenido adquirido es para uso personal y no comercial. Queda
          prohibida la reproducción, distribución o reventa del material sin
          autorización expresa.
        </p>
        <h4 className="text-white font-semibold text-base mt-4" data-id="element-109">
          3. Propiedad intelectual
        </h4>
        <p data-id="element-110">
          Todo el contenido, diseños, textos e imágenes son propiedad
          intelectual de "Etiquetas Sin Mentiras" y están protegidos por las
          leyes de derechos de autor aplicables.
        </p>
        <h4 className="text-white font-semibold text-base mt-4" data-id="element-111">
          4. Política de reembolso
        </h4>
        <p data-id="element-112">
          Debido a la naturaleza digital del producto y su entrega inmediata, no
          se ofrecen reembolsos una vez completada la descarga. Si experimentas
          problemas técnicos con la descarga, nos comprometemos a resolverlos.
        </p>
        <h4 className="text-white font-semibold text-base mt-4" data-id="element-113">
          5. Descargo de responsabilidad
        </h4>
        <p data-id="element-114">
          Este manual es una guía educativa e informativa. No sustituye el
          consejo médico o nutricional profesional. Consulta siempre con un
          profesional de la salud antes de realizar cambios significativos en tu
          alimentación.
        </p>
      </Modal>
    </>;
}